/**
 * 循環訂單狀態顏色（CycleOrderColorTypeEnum，後端以整數序列化）對應 Chip color。
 * 同時用於訂單狀態（statusColor）與變更單狀態（effectStatusColor）。
 *
 * 1 Green   正常-綠色 → success
 * 2 Blue    執行中-藍色 → info
 * 3 Grey    不重要-灰色 → gray
 * 4 Warning 警告-橘色 → warning
 * 9 Red     錯誤-紅色 → error
 */
const CYCLE_ORDER_STATUS_CHIP_COLOR = {
    1: 'success',
    2: 'info',
    3: 'gray',
    4: 'warning',
    9: 'error',
};

/**
 * 將狀態顏色 enum 轉為 Chip 的 color 值，未知值回傳 'gray'。
 * @param {number} colorEnum CycleOrderColorTypeEnum
 * @returns {string} Chip color
 */
export const matchCycleOrderStatusColor = (colorEnum) => CYCLE_ORDER_STATUS_CHIP_COLOR[colorEnum] ?? 'gray';

/**
 * 循環訂單選品頁中，會員可自行調整數量的商品類型（ProductTypeEnum）。
 *
 * 22 蛋白產品：可調整數量（同品類內重新分配盒數）
 * 其餘類型（23 益生菌、26 大包裝益生菌、24 鈣力嗨…）數量鎖定，一律沿用原訂單數量。
 *
 * 採白名單制：未列入者預設不可變更，日後後端新增商品類型時不會因為漏擋而放行。
 * 注意：這只是 UI 引導，實際限制由後端 CycleChangeFlavorProductDomain 把關
 * （各品類群組數量須與原訂單完全相同，不符回 CO026）。
 */
const CYCLE_PURCHASE_QTY_EDITABLE_PRODUCT_TYPES = new Set([22]);

/**
 * 判斷該商品類型是否允許會員調整數量。
 * @param {number} productType ProductTypeEnum
 * @returns {boolean} true 可調整數量；false 數量鎖定
 */
export const isCyclePurchaseQtyEditable = (productType) =>
    CYCLE_PURCHASE_QTY_EDITABLE_PRODUCT_TYPES.has(productType);
